import React, { Fragment } from "react";
import {
  FiActivity,
  FiAperture,
  FiBell,
  FiChevronRight,
  FiDollarSign,
  FiLogOut,
  FiSettings,
  FiUser,
} from "react-icons/fi";
import { Link } from "react-router-dom";
const activePosition = [
  "Active",
  "Always",
  "Busy",
  "Inactive",
  "Disabled",
  "Cutomization",
];
const subscriptionsList = [
  "Plan",
  "Billings",
  "Referrals",
  "Payments",
  "Statements",
  "Subscriptions",
];
const ProfileModal = () => {
  const name = localStorage.getItem("name");
  const roleName = localStorage.getItem("roleName");
  const number = localStorage.getItem("number");
  return (
    <div className="dropdown nxl-h-item">
      <a
        href="#"
        data-bs-toggle="dropdown"
        role="button"
        data-bs-auto-close="outside"
      >
        <div
          className="user-avtar rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
          style={{ width: "40px", height: "40px", fontSize: "18px" }}
        >
          {name?.charAt(0).toUpperCase() || ""}
        </div>
  
      </a>
      <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
        <div className="dropdown-header">
          <div className="d-flex align-items-center">
            <div
              className="user-avtar rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
              style={{ width: "40px", height: "40px", fontSize: "18px" }}
            >
              {name?.charAt(0).toUpperCase() || ""}
            </div>

            <div>
              <h6 className="text-dark mb-0">{name} </h6>
              <span className="fs-12 fw-medium text-muted">{roleName}</span>
            </div>
          </div>
        </div>
       
   
        <Link to="/reset-password" className="dropdown-item">
          <i>
            <FiAperture />
          </i>
          <span>Change Password</span>
        </Link>
    
        <div className="dropdown-divider"></div>
        <a href="/" className="dropdown-item">
          <i>
            {" "}
            <FiLogOut />
          </i>
          <span>Logout</span>
        </a>
      </div>
    </div>
  );
};

export default ProfileModal;

const getColor = (item) => {
  switch (item) {
    case "Always":
      return "always_clr";
    case "Busy":
      return "bussy_clr";
    case "Inactive":
      return "inactive_clr";
    case "Disabled":
      return "disabled_clr";
    case "Cutomization":
      return "cutomization_clr";
    default:
      return "active-clr";
  }
};
